import React from 'react'
import mobileBorder from '../../../../../assets/images/ads/mobile_border_shadow.png';
import preview1 from '../../../../../assets/images/ads/mobile_preview1.png';
import preview2 from '../../../../../assets/images/ads/mobile_preview2.png';
import preview3 from '../../../../../assets/images/ads/mobile_preview3.png';

const MobilePreview = ({ poster }) => {
    return (
        <>
            <div className="mobile_preview">
                <div className="mobile">
                    <figure className='border'>
                        <img src={mobileBorder} alt="mobile border" />
                    </figure>
                    <figure className='cnt'>
                        <img src={preview3} alt="preview image" />
                    </figure>
                    {
                        poster && (
                            <>
                                <figure className="poster">
                                    <img src={poster} alt="poster image" />
                                </figure>
                            </>
                        )
                    }
                </div>
                <div className="mobile">
                    <figure className='border'>
                        <img src={mobileBorder} alt="mobile border" />
                    </figure>
                    <figure className='cnt'>
                        <img src={preview2} alt="preview image" />
                    </figure>
                    {
                        poster && (
                            <figure className="poster">
                                <img src={poster} alt="poster image" />
                            </figure>
                        )
                    }
                </div>
                <div className="mobile">
                    <figure className='border'>
                        <img src={mobileBorder} alt="mobile border" />
                    </figure>
                    <figure className='cnt'>
                        <img src={preview1} alt="preview image" />
                    </figure>
                    {
                        poster && (
                            <figure className="poster">
                                <img src={poster} alt="poster image" />
                            </figure>
                        )
                    }
                </div>
            </div>
        </>
    )
}

export default MobilePreview